'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Shows a validation message if one exists.
 */
var FieldValidationMessages = function (_React$Component) {
    _inherits(FieldValidationMessages, _React$Component);

    function FieldValidationMessages() {
        _classCallCheck(this, FieldValidationMessages);

        return _possibleConstructorReturn(this, (FieldValidationMessages.__proto__ || Object.getPrototypeOf(FieldValidationMessages)).apply(this, arguments));
    }

    _createClass(FieldValidationMessages, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextProps.sanitisedError !== this.props.sanitisedError;
        }
    }, {
        key: 'render',
        value: function render() {
            var sanitisedError = this.props.sanitisedError;

            return sanitisedError && sanitisedError.message ? _react2.default.createElement(
                'div',
                { className: 'field-message error' },
                sanitisedError.message
            ) : null;
        }
    }]);

    return FieldValidationMessages;
}(_react2.default.Component);

FieldValidationMessages.propTypes = {
    sanitisedError: _propTypes2.default.object
};
exports.default = FieldValidationMessages;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/validation/FieldValidationMessages.js
// module id = 122
// module chunks = 0